import { useMutation } from "@tanstack/react-query";
import { requestURLs } from "../../Environment";
import {
  AxiosResponseAndError,
  ResponseType,
} from "@/api/types/axiosResponseType";
import ApiRequest from "../ApiRequest";

type RiskRemoveMemberResponseType = ResponseType<null>;

function useRemoveRiskMemberMutation() {
  const mutation = useMutation<
    AxiosResponseAndError<RiskRemoveMemberResponseType>["response"],
    AxiosResponseAndError<RiskRemoveMemberResponseType>["error"],
    string
  >({
    mutationFn: (data) =>
      ApiRequest.delete<RiskRemoveMemberResponseType>(
        `${requestURLs.risk}${data}`
      ),
  });

  return mutation;
}

export default useRemoveRiskMemberMutation;
